import { AimOutlined } from "@ant-design/icons";
import { Button, Col, Radio, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_OFFSET,
  STORE_FILTER_TYPE,
  WIDTH_IPAD,
} from "../../common/constant";
import FilterStoreAgencyModal from "../../components/filterStoreAgencyModal";
import StoreAgencyList from "../../components/storeAgencyList";
import StoreAgencyMap from "../../components/storeAgencyMap";
import { common } from "../../services";

const NearbyStores = (props: any) => {
  const { t } = useTranslation();
  const [idDistrict, setIdDistrict] = useState<number>();
  const [isAgency, setIsAgency] = useState(-1);
  const [cities, setCities] = useState<any>([]);
  const [districts, setDistricts] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [currentPosition, setCurrentPosition] = useState<any>({});
  const [center, setCenter] = useState<any>({});
  const [loadingMap, setLoadingMap] = useState(false);
  const [districtId, setDistrictId] = useState(null);
  //   const [isAgency, setIsAgency] = useState(null);
  const [isSetCenter, setIsSetCenter] = useState(true);

  useEffect(() => {
    if (!cities.length) {
      setLoading(true);

      common.getDistrictStore((data, err) => {
        if (data) {
          setCities(data.docs);
          setLoading(false);
        }
      });
    }

    getCurrentPosition();
  }, []);

  const handleChangeCity = (value: number) => {
    const findCity = cities.find((city: any) => city.id === value);

    if (findCity) {
      setDistricts(findCity.data);
    }
  };

  const handleChangeDistrict = async (value: number) => {
    setIdDistrict(value);
    await getFilters(value, isAgency);
  };

  const getStores = (position: any) => {
    const query = {
      offset: DEFAULT_OFFSET,
      limit: 10,
      lat: position.lat,
      lng: position.lng,
    };

    common.getStores(query, (data, err) => {
      if (data) {
        setStores(data.docs);
        setLoadingMap(false);
      }
    });
  };

  const getCurrentPosition = () => {
    setLoadingMap(true);
    navigator.geolocation.getCurrentPosition((position: any) => {
      setCurrentPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      getStores({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      setLoadingMap(false);
    });
  };

  const getFilters = (idDistrict: any, isAgency: any) => {
    setDistrictId(idDistrict);
    setIsAgency(isAgency);
  };

  const getStoresWithFilters = async () => {
    setLoadingMap(true);
    const query = {
      district_id: districtId,
      is_agency: isAgency === -1 ? undefined : isAgency,
    };

    common.getStoresWithFilters(query, (data, err) => {
      if (data) {
        if (data.docs.length) {
          setCenter({
            lat: +parseFloat(data.docs[0].location.coordinates[1]),
            lng: +parseFloat(data.docs[0].location.coordinates[0]),
          });
        }

        setStores(data.docs);
        setLoadingMap(false);
      }
    });
  };

  const handleGetCenter = () => {
    navigator.geolocation.getCurrentPosition((position: any) => {
      setCurrentPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      setIsSetCenter(!isSetCenter);
    });
  };

  const handleOk = async () => {
    await getStoresWithFilters();
  };

  return (
    <>
      {window.innerWidth >= WIDTH_IPAD ? (
        <Col
          span={24}
          style={{ marginBottom: 20 }}
          className="nearby-store--desktop">
          <Row>
            <Col xs={24} md={2} className="reviews-wrap"></Col>
            <Col
              // span={24}
              xs={24}
              md={22}
              style={{ backgroundColor: "rgba(225,225,225,0.2)" }}>
              <Row align="top" wrap={true}>
                <Col xs={24} md={10} className="nearby-store-filter">
                  <p className="nearby-store-filter__title main-content">
                    Tìm kiếm cửa hàng / đại lý trong bán kính 5km
                  </p>

                  <Radio.Group
                    className="nearby-store-filter__radio-btn radio-group"
                    defaultValue={-1}
                    buttonStyle="solid"
                    onChange={(e) => {
                      setIsAgency(e.target.value);
                      // getFilters(idDistrict, e.target.value);
                    }}>
                    {STORE_FILTER_TYPE.map((item: any) => (
                      <Radio.Button
                        key={item.value}
                        value={item.value}
                        className="sub-content">
                        {t(item.label)}
                      </Radio.Button>
                    ))}
                  </Radio.Group>

                  <div className="nearby-store-filter__location filter-city-district">
                    <Select
                      className="select-item sub-content"
                      dropdownClassName="nearby-store-filter__location-select-item-dropdown"
                      showSearch
                      placeholder={t("field_city")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      loading={loading}
                      onChange={handleChangeCity}>
                      {cities.map((city: any) => (
                        <Select.Option
                          key={city.id}
                          value={city.id}
                          className="sub-content">
                          {city.name}
                        </Select.Option>
                      ))}
                    </Select>

                    <Select
                      className="select-item sub-content"
                      dropdownClassName="nearby-store-filter__location-select-item-dropdown__district"
                      showSearch
                      placeholder={t("field_district")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      onChange={handleChangeDistrict}>
                      {districts?.map((district: any) => (
                        <Select.Option
                          key={district.id}
                          value={district.id}
                          className="sub-content">
                          {district.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>

                  <div className="nearby-store-filter__button">
                    <a
                      className="nearby-store-filter__button-reset"
                      onClick={handleGetCenter}>
                      {/* Thiết lập lại */}
                      Vị trí hiện tại
                    </a>
                    <Button
                      className="nearby-store-filter__button-apply"
                      onClick={handleOk}
                      disabled={!idDistrict ? true : false}>
                      Áp dụng
                    </Button>
                  </div>

                  <StoreAgencyList stores={stores} />
                </Col>
                <Col xs={24} md={14}>
                  <div className="map-stores-list-container">
                    <StoreAgencyMap
                      loading={loadingMap}
                      currentPosition={currentPosition}
                      center={center}
                      stores={stores}
                      getFilters={getFilters}
                      getStoresWithFilters={getStoresWithFilters}
                      isSetCenter={isSetCenter}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      ) : (
        <div className="nearby-store--mobile">
          <div className="filter-container">
            <FilterStoreAgencyModal
              getFilters={getFilters}
              getStoresWithFilters={getStoresWithFilters}
            />
            &nbsp;
            <Button
              icon={<AimOutlined size={18} />}
              onClick={handleGetCenter}
            />
          </div>

          <StoreAgencyMap
            loading={loadingMap}
            currentPosition={currentPosition}
            center={center}
            stores={stores}
            getFilters={getFilters}
            getStoresWithFilters={getStoresWithFilters}
            isSetCenter={isSetCenter}
          />

          <StoreAgencyList stores={stores} />
        </div>
      )}
    </>
  );
};

export default NearbyStores;
